// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const List: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19.375" height="16.25">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M0 .938C0 .42.42 0 .938 0h1.875c.519 0 .937.42.937.938v1.875c0 .519-.418.937-.938.937H.938A.936.936 0 0 1 0 2.812V.938ZM2.5 2.5V1.25H1.25V2.5H2.5Zm16.25-1.25a.626.626 0 0 1 0 1.25H6.25a.626.626 0 0 1 0-1.25h12.5Zm0 6.25c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625H6.25a.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625h12.5Zm0 6.25c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625H6.25a.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625h12.5ZM2.812 6.25c.52 0 .938.418.938.938v1.875c0 .519-.418.937-.938.937H.938A.936.936 0 0 1 0 9.062V7.188c0-.52.42-.938.938-.938h1.875ZM1.25 7.5v1.25H2.5V7.5H1.25ZM0 13.438c0-.52.42-.938.938-.938h1.875c.519 0 .937.418.937.938v1.874c0 .52-.418.938-.938.938H.938A.936.936 0 0 1 0 15.312v-1.874ZM2.5 15v-1.25H1.25V15H2.5Z"
            />
        </svg>
    );
};

export default React.memo(List);
